import { l } from '../../lscript/template';
import { defCustomUnit, defBaseUnit } from '../registry';

export const temperatureUnits = [
  defBaseUnit('celsius'),
  defCustomUnit('kelvin', { kelvin: 1 }, 'celsius', {
    toBase: (v) => l`${v} - 273.15`,
    fromBase: (v) => l`${v} + 273.15`,
  }),
  defCustomUnit('fahrenheit', { fahrenheit: 1 }, 'celsius', {
    toBase: (v) => l`(${v} - 32) * 5/9`,
    fromBase: (v) => l`${v} * 9/5 + 32`,
  }),
];
